import React from "react";

export const MainCopy = () => (
  <p>
    Choose up to three (3) practice areas that you specialize in. We&apos;ll use
    these to match you with hiring agents/agencies who are looking for
    candidates with experience in these areas.
  </p>
);
